import { render, staticRenderFns } from "./AboutElement.vue?vue&type=template&id=14b5723c&scoped=true&"
import script from "./AboutElement.vue?vue&type=script&lang=js&"
export * from "./AboutElement.vue?vue&type=script&lang=js&"
import style0 from "./AboutElement.vue?vue&type=style&index=0&id=14b5723c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b5723c",
  null
  
)

export default component.exports